<div class="popper-content" [class.grow]="growing && !closing" [ngStyle]="popperStyle" *ngIf="data.open" [variableBackdrop]="growing" (backdropClicked)="close()" (mouseleave)="close()">
  <div *ngIf="data && data.tag" [ngStyle]="contentStyle">
    <!--{{data.tag}}-->
    <list [list]="data.tag"></list>
  </div>
</div>